// src/components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Protection des routes admin
const ProtectedRoute = ({ requiredRole }) => {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  
  // Si l'utilisateur n'est pas connecté, rediriger vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Si un rôle spécifique est requis et que l'utilisateur n'a pas ce rôle
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // Si l'utilisateur est connecté et a le rôle requis (ou aucun rôle n'est requis),
  // afficher les routes enfants
  return <Outlet />;
};

export default ProtectedRoute;